import {
  Icons,
  HexIcon,
  Placeholder as StatusMessage,
} from '@cast/design-system';

import { useCostReportContext } from 'features/cost-report/hooks/useCostReportContext';
import {
  isDataProcessing as isDataProcessingStatus,
  NoDataType,
} from 'features/cost-report/types/common';

export const NoData = ({
  dataType = NoDataType.GENERAL,
}: {
  dataType?: NoDataType;
}) => {
  const { dataStatus } = useCostReportContext();

  const getStatus = () => {
    switch (dataType) {
      case NoDataType.NETWORK:
        return dataStatus.network;
      case NoDataType.GPU:
        return dataStatus.gpu;
      default:
        return dataStatus.reporting;
    }
  };

  const isDataProcessing = isDataProcessingStatus(getStatus());

  return (
    <StatusMessage
      testId={
        isDataProcessing
          ? 'cost-report-no-data-processing'
          : 'cost-report-no-data'
      }
      title={isDataProcessing ? 'Data is being processed' : 'No data found'}
      body={
        isDataProcessing
          ? 'For newly connected clusters, it might take up to 15 minutes for the data to be available.'
          : 'Try selecting a different time period.'
      }
      icon={
        <HexIcon
          variant="notification"
          icon={
            isDataProcessing ? (
              <Icons.HourglassHigh weight="fill" />
            ) : (
              <Icons.Question weight="fill" />
            )
          }
          size={84}
        />
      }
    />
  );
};
